/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import React, {
  ChangeEvent,
  forwardRef,
  useEffect,
  useRef,
  useState,
} from 'react';
import { TransitionProps } from '@mui/material/transitions';
import {
  // Backdrop,
  Button,
  // CircularProgress,
  Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, IconButton, Input, Radio, RadioGroup, Zoom,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
// import { Editor } from 'react-draft-wysiwyg';
// import { stateToHTML } from 'draft-js-export-html';
// import { ContentState, EditorState } from 'draft-js';
// import htmlToDraft from 'html-to-draftjs';
import { yupResolver } from '@hookform/resolvers/yup';
import { ObjectSchema } from 'yup';
import Editor, { ContentEditableEvent } from 'react-simple-wysiwyg';
import { useParams } from 'react-router-dom';
import ComponentTextInput from '../../../Common/ComponentTextinput/ComponentTextInput';
import RequiredFiled from '../../../Common/RequiredField';
import { GetUserDetailsPayload, SendEmailFormValues, TypesSendEmailDialogBox } from '../utils/types';
import {
  radioOptions, SendEmailForm, sendEmailSchema, SendMailDefaultValue,
} from '../utils/helper';
// import { customOptions } from '../../../Common/TextEditorOptions';
import { AttachmentIcon } from '../../../assets/TableIcons/AttachmentIcon';
import { clearIsEmailSent, getUserDetailsListStart, sendEmailStart } from '../redux/sliceReportWorkspace';
import { RootState } from '../../../redux/rootState';
import styles from '../utils/reportingStyle.module.scss';
// import { showSuccessToaster } from '../../../Common/ComponentToast/ComponentSuccessToasts';
import { addJobOrderEmailFlag } from '../../oilReport/redux/oilReportSlice';
import ConfirmationModal from '../../../Common/ConfirmationModal/ConfirmationModal';
import { ConfirmationIcon } from '../../../assets/Icons/AnalystIcons/ConfirmationIcon';
import english from '../../../assets/lang/english';
import { showErrorToaster } from '../../../Common/ComponentToast/ComponentSuccessToasts';

const Transition = forwardRef((
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) => <Zoom ref={ref} {...props} />);

function ComponentSendEmailModel({
  show, setOpenFrom, emailsData, handleClear,
}: TypesSendEmailDialogBox): JSX.Element {
  const dispatch = useDispatch();
  const { UserDetailsData, isEmailSent } = useSelector((state: RootState) => state.reportWorkspaceReducer);
  const { isJOFlagAdded } = useSelector((state: RootState) => state.oilReportReducer);
  const { userProfile } = useSelector((state: RootState) => state.userProfileReducer);

  const [comment, setComment] = useState<string>('');
  const [fileValidationModal, setFileValidationModal] = useState<boolean>(false);
  const [radioVal, setRadioVal] = useState<string>('1');
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [plainText, setPlainText] = useState<string>('');
  const MAX_CHARACTER_LIMIT = 3000;
  const { id } = useParams();

  const {
    control, formState: { errors }, handleSubmit, setValue,
  } = useForm<SendEmailFormValues>({
    defaultValues: SendMailDefaultValue as unknown as SendEmailFormValues,
    resolver: yupResolver(sendEmailSchema as ObjectSchema<SendEmailFormValues>),
  });

  useEffect(() => {
    setValue('cc', userProfile?.Email?.trim());
  }, [userProfile]);

  useEffect(() => {
    if (UserDetailsData?.SubjectComments) {
      const data = radioOptions?.find((item) => item?.value === String(UserDetailsData?.SubjectComments));
      switch (data?.value) {
        case '2':
          setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''} - ${data.label}`);
          break;
        case '3':
          setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''} - ${data.label}`);
          break;
        case '4':
          setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''} - ${data.label}`);
          break;
        case '5':
          setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''} - ${data.label}`);
          break;
        default:
          setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''}`);
          break;
      }

      const body = `Your latest report from TAI Services is attached. If
you have received a PDF file, the Adobe Reader will allow you to open, view and print the test
results. After reviewing your report, if you have technical questions, call (800) 554-4127. Ask for
Michael Johnson Or Ray Bernstein. If you have a Logo your company uses, or would like to change
the logo being used, preferably on a white background, we could use it on your reports.
Please email it to us and we will customize your reports.<br /><br />
We appreciate your business and look forward to being of service to your Company again.<br /><br />
Thank you for using TAI Services, Inc.<br />
Macy Hall<br />
Technical Services Coordinator<br />
TAI Services, Inc.<br /><br />
This report is for unit ${UserDetailsData?.SerialNumber}, located at ${UserDetailsData?.SiteName}`;

      setComment(body);
      setRadioVal(String(UserDetailsData?.SubjectComments));
    }
  }, [UserDetailsData]);

  const handleClose = () => {
    setSelectedFile(null);
    handleClear();
    setOpenFrom();
  };

  const fileInputRef = useRef(null);
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;
    if (files && files.length > 0) {
      const selected = files[0];
      const fileExtension = selected.name.split('.').pop()?.toLowerCase();
      // const fileSizeInKB = selected.size / 1024; // Convert bytes to KB

      const allowedExtensions = ['pdf'];
      // const maxSizeInKB = 5120; // 5 MB = 5120 KB

      if (!allowedExtensions.includes(fileExtension || '')) {
        showErrorToaster('Invalid file format. Please upload a PDF file (.pdf).');
      // } else if (fileSizeInKB > maxSizeInKB) {
      //   showErrorToaster('File size exceeds 5MB. Please upload a smaller PDF.');
      } else {
        setSelectedFile(selected);
        // showSuccessToaster('File attached successfully');
      }
    }
  };

  useEffect(() => {
    if (selectedFile && selectedFile?.name !== `${UserDetailsData?.SiteName?.replace(/[\r\n]+/g, ' ')?.trim() || ''}_${UserDetailsData?.SerialNumber || ''}.pdf`) {
      setFileValidationModal(true);
    }
  }, [selectedFile]);

  useEffect(() => {
    setValue(SendEmailForm.to, emailsData);
  }, [emailsData]);

  const handleComment = (event: ContentEditableEvent) => {
    const htmlContent = event.target.value;
    const tempDivElement = document.createElement('div');
    tempDivElement.innerHTML = htmlContent;
    const plainTextContent = tempDivElement.textContent || tempDivElement.innerText || '';

    if (plainTextContent.length <= MAX_CHARACTER_LIMIT) {
      setComment(htmlContent);
      setPlainText(plainTextContent);
    }
  };

  useEffect(() => {
    const tempDivElement = document.createElement('div');
    tempDivElement.innerHTML = comment;
    const plainTextContent = tempDivElement.textContent || tempDivElement.innerText || '';

    if (plainTextContent.length <= MAX_CHARACTER_LIMIT) {
      setComment(comment);
      setPlainText(plainTextContent);
    }
  }, [comment]);

  const onSubmit = (values: SendEmailFormValues) => {
    const formData = new FormData();

    if (selectedFile) {
      formData.append('File', selectedFile);
    }
    formData.append('RecieverMail', values.to ?? '');
    formData.append('Subject', values.subject ?? '');
    formData.append('Body', comment ?? '');
    formData.append('CcMail', values.cc ?? '');
    formData.append('Type', '3');
    dispatch(sendEmailStart(formData));
    // handleClose();
  };

  useEffect(() => {
    if (isEmailSent) {
      dispatch(clearIsEmailSent());
      const payload = {
        jobOrder: id || '',
      };
      dispatch(addJobOrderEmailFlag(payload));
      // handleClose();
    }
  }, [isEmailSent]);

  useEffect(() => {
    if (isJOFlagAdded) {
      handleClose();
    }
  }, [isJOFlagAdded]);

  const handleTestTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRadioVal(e.target.value);
    const data = radioOptions.find((item) => item.value === e.target.value);
    switch (data?.value) {
      case '2':
        setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''} - ${data.label}`);
        break;
      case '3':
        setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''} - ${data.label}`);
        break;
      case '4':
        setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''} - ${data.label}`);
        break;
      case '5':
        setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''} - ${data.label}`);
        break;
      default:
        setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''}`);
        break;
    }
  };

  useEffect(() => {
    const payload = {
      jobOrderId: id,
    };
    dispatch(getUserDetailsListStart(payload as GetUserDetailsPayload));
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Dialog
        maxWidth="lg"
        PaperProps={{
          className: 'paperStyle',
        }}
        open={show}
        transitionDuration={500}
        TransitionComponent={Transition}
        keepMounted
        onClose={setOpenFrom}
        onClick={(e) => e.stopPropagation()}
      >
        {/* {
        isLoading && (
        <Backdrop
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress />
        </Backdrop>
        )
        } */}
        <DialogTitle className="modalHeaderTitle">
          Send Email
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
          <div className="div_label_text" style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid rgb(211, 209, 209)' }}>
            <label className="label_Style_job" style={{ marginBottom: '-5px' }}>Subject Comments</label>
            <FormControl>
              <RadioGroup
                row
                value={radioVal}
                onChange={(event) => {
                  handleTestTypeChange(event);
                }}
              >
                {radioOptions.map((option) => (
                  <div className="type_of_test" key={option.value}>
                    <FormControlLabel
                      labelPlacement="start"
                      value={option.value}
                      control={<Radio color="success" />}
                      label={<span className="radio_button_style">{option.label}</span>}
                    />
                  </div>
                ))}
              </RadioGroup>
            </FormControl>
          </div>
        </DialogTitle>
        <DialogContent className={styles.DialogContentStyle}>
          <form noValidate>
            <Grid container spacing={2}>
              <Grid item md={12} sm={12} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    To:
                    <RequiredFiled />
                  </label>
                  <ComponentTextInput
                    control={control}
                    className="nonCapitalizeField"
                    name={SendEmailForm.to}
                    size="small"
                    id={SendEmailForm.to}
                    inputProps={{ maxLength: 250 }}
                    errors={errors}
                  />
                </div>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">CC:</label>
                  <ComponentTextInput
                    control={control}
                    className="nonCapitalizeField"
                    name={SendEmailForm.cc}
                    size="small"
                    id={SendEmailForm.cc}
                    errors={errors}
                    inputProps={{ maxLength: 250 }}
                  />
                </div>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Subject:
                    <RequiredFiled />
                  </label>
                  <ComponentTextInput
                    control={control}
                    className="nonCapitalizeField"
                    name={SendEmailForm.subject}
                    size="small"
                    id={SendEmailForm.subject}
                    errors={errors}
                    inputProps={{ maxLength: 500 }}
                  />
                </div>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Input
                    type="file"
                    inputProps={{ accept: '.pdf', style: { display: 'none' } }}
                    id="fileInputEmail"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                  />
                  <label htmlFor="fileInputEmail">
                    <Button className="button_save_and_next" component="span">
                      <AttachmentIcon />
                    </Button>
                  </label>
                </div>
                <div className={styles.pdfFileName}>
                  <label>{selectedFile?.name}</label>
                </div>
                <div className={styles.SendEmailEditor}>
                  <Editor value={comment} onChange={handleComment} tagName="p" />
                </div>
                <div className={styles.CharacterCount}>
                  <span>
                    {plainText?.length}
                    /
                    {MAX_CHARACTER_LIMIT}
                    {' '}
                    Characters
                  </span>
                </div>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <div className="save_and_next_div">
                  <div>
                    <Button className="button_cancel" onClick={handleClose}>Cancel</Button>
                  </div>
                  <div className="button_margin_left">
                    <Button disabled={selectedFile === null} type="submit" className="button_save_and_next">Send Email</Button>
                  </div>
                </div>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
      {fileValidationModal && (
        <ConfirmationModal
          readOnly
          show={fileValidationModal}
          setOpenFrom={() => setFileValidationModal(false)}
          // eslint-disable-next-line max-len
          text={english.FileValidationMsg}
          confirmationIcon={<ConfirmationIcon />}
        />
      )}
    </form>
  );
}

export default ComponentSendEmailModel;
